export enum SynchronizeActions {
  StartSync = 'SYNCHRONIZE/Starting synchronization with API',
  SyncCompleted = 'SYNCHRONIZE/Synchronization with API completed',
  SyncRejected = 'SYNCHRONIZE/Synchronization with API rejected',
  NewChanges = 'SYNCHRONIZE/Synchronization detected difference between API and redux',
  RequestSync = 'SYNCHRONIZE/Synchronization request sync',
  RequestContinuousSync = 'SYNCHRONIZE/Synchronization request continuous sync',

  SetSyncDate = 'SYNCHRONIZE/Set sync last time date',

  FirstSync = 'SYNCHRONIZE/Starting first synchronization for this session',
  FlushDataForSync = 'SYNCHRONIZE/Request remove old data for sync',
  FlushedDataForSync = 'SYNCHRONIZE/Old data was removed to keep consistency between devices',

  RequestRoomsFlush = 'SYNCHRONIZE/Request to remove all rooms data',
  RoomsFlushed = 'SYNCHRONIZE/All Rooms flushed',

  RequestEventsFlush = 'SYNCHRONIZE/Request to remove all events data',
  EventsFlushed = 'SYNCHRONIZE/All Events flushed',

  FlushError = 'SYNCHRONIZE/Error has occurred when flushing database',
  ReloadApp = 'Reload app data from server',
  NewVersion = 'new version available',
  Version = 'version',
  VersionConsistent = 'versions are consistent',
  VersionInconsistent = 'versions are inconsistent',
  ToggleNewVersionModal = 'toggle modal new version available',
  FetchConsecutiveErrors = 'Fetch has consecutive errors',
}
